import { IBot } from "server/src/ai/interface/IBot";
import { IParam } from "./interface/IParam"

export const typeMoveBot:string = "move_bot"
export const typeSelectBot:string = "select_bot"
export const typeMoveParam:string = "move_param"
export const typeMoveObj:string = "move_obj"
export const typeMoveCtx:string = "move_ctx"
export const typeSelectCtx:string = "select_ctx"

export const typeCtxParam:string = "ctx_param"
export const typeDatasourceParam:string = "datasource_param"



interface ITooltip {
    show:boolean,
    x:number,
    y:number,
    title: string
    key:number
  }

export class DragManager {

    private static instance: DragManager;

    public sourceBot: IBot | undefined
    public sourceParam: IParam | undefined
    public sourceObj: any

    private obj:any={};
    tooltip: ITooltip = {show:false, x:0, y:0, title:"", key:0}
    
    private constructor() { }

    static getInstance(): DragManager {
        if (!DragManager.instance) {
            DragManager.instance = new DragManager();
        }
        return DragManager.instance;
    }

    public set(o:any, type:string) {
        this.obj[type]=o
        console.log("DragManager set", type)
    }

    public get(type:string) {
        return this.obj[type]
    }

    public reset(type:string) {
        this.obj[type]=undefined
        console.log("DragManager reset", type)
    }

    show_tooltip(title:string, x:number|undefined, y:number|undefined) {
        this.tooltip.show=true
        this.tooltip.x=x||0
        this.tooltip.y=y||0
        this.tooltip.title=title
        this.tooltip.key++
    }
    
    move_tooltip(x:number|undefined, y:number|undefined) {
        this.tooltip.show=true
        this.tooltip.x=x||0
        this.tooltip.y=y||0
        this.tooltip.key++
    }

    hide_tooltip() {
        this.tooltip.show=false
        this.tooltip.key++
    }
    

}
